// extracted by mini-css-extract-plugin
export default {"outerClass":"NetWorth_outerClass__KWHSA","header":"NetWorth_header__5O0TX","headTag":"NetWorth_headTag__7KB0c","amtTag":"NetWorth_amtTag__ZC89M","center":"NetWorth_center__D0bK4"};